import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from '@/lib/queryClient';
import { router } from '@/routes/router';
import { installRefreshLoop, uninstallRefreshLoop } from '@/auth/refreshLoop';
import { installCookieSync, uninstallCookieSync } from '@/auth/cookieSync';

export default function App() {
    useEffect(() => {
        installRefreshLoop();
        installCookieSync();
        return () => {
            uninstallRefreshLoop();
            uninstallCookieSync();
        };
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
            <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
        </QueryClientProvider>
    );
}
